export default class RadioButtonGroup {
    constructor(buttons) {
        this.buttons = buttons;
        this.current = buttons[0].value;

        for (let i = 0; i < buttons.length; i++) {
            buttons[i].button.inputEnabled = true;
            buttons[i].button.events.onInputUp.add(this.clickButton.bind(this, i));
            buttons[i].bullet.visible = false;
        }

        buttons[0].bullet.visible = true;
    }

    clickButton(choice) {
        for (let i = 0; i < this.buttons.length; i++) {
            this.buttons[i].bullet.visible = false;
        }

        this.buttons[choice].bullet.visible = true;
        this.current = this.buttons[choice].value;
    }

    enable() {
        for (let j = 0; j < 2; j++) {
            this.buttons[j].visible = true;
        }
    }

    disable() {
        for (let j = 0; j < 2; j++) {
            this.buttons[j].visible = false;
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/objects/ui/RadioButtonGroup.js
// module id = 145
// module chunks = 0